import React from "react";
import { FormControl, InputAdornment, TextField, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { SearchInputStyled } from "./SearchInputStyled";

const SearchInput = ({ placeholder, onSearchChange }) => {
  const handleChange = (event) => {
    onSearchChange(event?.target?.value);
  };

  return (
    <FormControl className="formControlWidth">
      <Box className="searchInput">
        <TextField className="searchTextBox"
          size="small"
                  variant="outlined"
                  onClick={(e) => {
                      e.stopPropagation();
                  } }
          placeholder={placeholder}
          onChange={handleChange}
                  InputProps={{
                      onFocus: (e) => {
                          e.stopPropagation();
                      },
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </FormControl>
  );
};

export default SearchInput;
